
//DEV ENV
export const local = {
  api: {
    url: process.env.REACT_APP_API_URL,
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

export const development = {
  api: {
    // Hardcoded (like staging/prod/uk) so the dev API URL lives in the repo and
    // doesn't depend on a GitLab CI/CD `REACT_APP_API_URL` variable. Rebrand: foreseesecurity.io
    url: 'https://devapi.foreseesecurity.io/nmt/api/v1/',
    // Hardcoded gate Basic-auth — same value SbomApiIntercepter.js already hardcodes.
    // Avoids a trailing-newline in the GitLab `REACT_APP_API_KEY` variable breaking login.
    AUTH: 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2',
  },
};

//STAGE ENV 
export const staging = {
  api: {
    url: 'https://stagapi.foreseesecurity.io/nmt/api/v1/',
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

//PRODUCTION ENV
// Rebrand: nmtsecurity.com → foreseesecurity.io (frontend dashboard.foreseesecurity.io,
// API prodapi.foreseesecurity.io). Same registrable domain, so API calls are same-site.
export const prod = {
  api: {
    url: 'https://prodapi.foreseesecurity.io/nmt/api/v1/',
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

//UK ENV
export const uk = {
  api: {
    url: 'https://ukprodapi.foreseesecurity.io/nmt/api/v1/',
    AUTH: process.env.REACT_APP_API_KEY
  },
};
